import React, { useCallback, useEffect, useMemo, useState } from "react";

import { FieldDescription } from "./Chart";
import { transferItem } from "./";
import instance from "../../util/axios";
import Chart from "./Chart";
import { Popover, Toast } from "antd-mobile-v5";
import { timeSlotChange } from "../EnterpriseWechat/CustomersAndGroups/CustomerBase/component/dataFormat";
import { Action } from "antd-mobile-v5/es/components/popover";
import "./style.css";
interface DesignerProps {
  selectedObject: transferItem[];
  fieldJoins?: { [key: string]: string }[];
  defaultReportData?: ReportDef;
  name: string;
  id: string;
  showReport?: string;
  showStatisticalChart?: string;
  chartHeight?: number | string;
  isApp?: string;
}

const actions: Action[] = [
  {
    text: "全部",
    key: "",
  },
  {
    text: "今日",
    key: timeSlotChange("今天")
      .map((item) => item.slice(0, 10))
      .join("~"),
  },
  {
    text: "本周",
    key: timeSlotChange("本周")
      .map((item) => item.slice(0, 10))
      .join("~"),
  },
  {
    text: "本月",
    key: timeSlotChange("本月")
      .map((item) => item.slice(0, 10))
      .join("~"),
  },
  {
    text: "本年",
    key: timeSlotChange("今年")
      .map((item) => item.slice(0, 10))
      .join("~"),
  },
];

export interface ReportDef {
  name: string;
  uuid: string;
  topFields: { [key: string]: any }[];
  leftFields: { [key: string]: any }[];
  aggregateDefs: { [key: string]: any }[];
  objectDefs: { [key: string]: any }[];
  preDefinedFiltersForAggregate: any[];
  preDefinedFiltersForReport: FieldDescription[];
  joins: { [key: string]: any }[];
  filters: { [key: string]: any }[];
  reportFromRow: number;
  sheetContent: { [key: string]: any }[];
  statistiChartType: "bar" | "line" | "pie" | "map";
}

export default function Designer({
  selectedObject = [],
  fieldJoins = [],
  id = "",
  name,
  defaultReportData,
  showReport,
  showStatisticalChart,
  chartHeight,
  isApp,
}: DesignerProps) {
  const [chartType, setChartType] = useState<"bar" | "line" | "pie" | "map">(
    "bar"
  );

  //统计数据
  const [reportForm, setReportForm] = useState<ReportDef>();

  //筛选弹窗的字段
  const [dataSource, setDataSource] = useState<FieldDescription[]>([]);

  //统计图数据
  const [chartDataSource, setChartDataSource] = useState<any>();

  //时间筛选数据
  const [nodeData, setNodeData] = useState<any>({
    text: "全部",
    key: "",
    viseable: false,
    data: [],
  });
  //通过上一步选择的表名,查询所有字段
  useEffect(() => {
    (async () => {
      if (selectedObject.length > 0) {
        const fields = [];
        for (let i = 0; i < selectedObject.length; i++) {
          const resp = await instance.post(
            "/crm/systemConfig/fieldDescription/getFieldDescriptionList",
            {
              tableName: selectedObject[i].tableName,
            }
          );
          if (resp.data.Status === "1") {
            fields.push(
              ...resp.data.Data.map((item: any) => {
                return {
                  ...item,
                  dictionary:
                    item.inputType === 4 ? item.fieldName : item.dictionary,
                };
              })
            );
          }
        }
        setDataSource(fields);
      }
    })();
  }, [selectedObject]);

  useEffect(() => {
    if (dataSource.length > 0) {
      if (defaultReportData && JSON.stringify(defaultReportData) !== "{}") {
        defaultReportData.aggregateDefs &&
          defaultReportData.aggregateDefs.length > 0 &&
          defaultReportData.aggregateDefs.forEach((item, i) => {
            if (
              defaultReportData.preDefinedFiltersForAggregate[i] &&
              defaultReportData.preDefinedFiltersForAggregate[i].length > 0
            ) {
              item.hasPreDefinedFilters = true;
            }
          });
        setChartType(defaultReportData.statistiChartType);
        fill(
          defaultReportData,
          undefined,
          defaultReportData.preDefinedFiltersForAggregate,
          defaultReportData.preDefinedFiltersForReport,
          [],
          defaultReportData.reportFromRow
        );
      }
    }
  }, [dataSource.length, defaultReportData]);

  const fill = useCallback(
    async (
      reportData,
      type = "",
      aggFilter = [],
      preDefinedFiltersForReport = [],
      reportFilters = [],
      fromRow?: number
    ) => {
      if (type === "aggregate_delete") return;
      if (type === "filter") return;
      reportData.objectDefs = selectedObject;
      reportData.joins = fieldJoins;
      reportData.aggregateDefs = reportData.aggregateDefs.map((item: any) => ({
        ...item,
        aggregateType: item.aggregateType || "sum",
      }));
      reportData.preDefinedFiltersForReport =
        preDefinedFiltersForReport.length > 0
          ? preDefinedFiltersForReport.map((item: { fieldName: string }) => ({
              ...item,
              fieldNames: item.fieldName,
            }))
          : []; //默认报表的预定义筛选条件
      const newAggFilter: (any[] | null)[] = [];
      aggFilter.forEach((agg: any[]) => {
        if (agg && agg.length > 0) {
          newAggFilter.push(
            agg.map((aggItem) => ({
              ...aggItem,
              fieldNames: aggItem.fieldName,
            }))
          );
        } else {
          newAggFilter.push(null);
        }
      });
      reportData.preDefinedFiltersForAggregate = newAggFilter;

      setReportForm(reportData);
      const copyReportData = JSON.parse(JSON.stringify(reportData));
      delete copyReportData.sheetContent;
      if (reportFilters.length > 0) {
        copyReportData.filters = reportFilters.map(
          (item: { fieldName: string }) => ({
            ...item,
            fieldNames: item.fieldName,
          })
        );
      }
      if (
        copyReportData &&
        copyReportData.filters &&
        copyReportData.filters.length > 0
      ) {
        let flag = true;
        for (let i = 0; i < copyReportData.filters.length; i++) {
          if (copyReportData.filters[i].filterType === "date" && flag) {
            setNodeData((prevState: any) => ({
              ...prevState,
              visiable: true,
            }));
            flag = false;
          }
        }
        setNodeData((prevState: any) => ({
          ...prevState,
          data: copyReportData.filters,
          visiable: true,
        }));
      }
      const resp = await instance.post("/chart/report/fill", {
        reportDef: JSON.stringify(copyReportData),
      });
      if (resp.data.Status !== "1") return;
      const dicts = resp.data.Data.dicts;
      const datas = resp.data.Data.data;

      //生成图表数据
      const data_extra = resp.data.Data.data_extra;
      if (
        (reportData.topFields.length === 1 ||
          reportData.leftFields.length === 1) &&
        reportData.aggregateDefs.length > 0
      ) {
        const chartData = [...datas];
        if (data_extra && JSON.stringify(data_extra) !== "{}") {
          for (const de in data_extra) {
            chartData.push(
              ...data_extra[de].map((dataExtraItem: any) => ({
                ...dataExtraItem,
                index: parseInt(de),
              }))
            );
          }
        }
        if (
          ((reportData?.topFields.length === 1 &&
            reportData?.leftFields.length === 0) ||
            (reportData?.leftFields.length === 1 &&
              reportData?.topFields.length === 0)) &&
          reportData?.aggregateDefs.length > 0
        ) {
          setChartDataSource({
            data: chartData,
            dicts: dicts,
            aggFields: reportData.aggregateDefs.map(
              (agg: { fieldName: string }, ai: number) => {
                if (
                  reportData.preDefinedFiltersForAggregate[ai] &&
                  reportData.preDefinedFiltersForAggregate[ai].length > 0
                ) {
                  return agg.fieldName + ai;
                }
                return agg.fieldName;
              }
            ),
            titles: reportData.aggregateDefs.map(
              (agg: {
                fieldName: string;
                title: string;
                fieldShowName: string;
              }) => agg.title || agg.fieldShowName || agg.fieldName
            ),
          });
        } else {
          setChartDataSource(null);
        }
      }
    },
    [fieldJoins, selectedObject]
  );
  console.log(chartDataSource);
  return (
    <>
      {chartDataSource && (
        <>
          <div
            style={{
              padding: 12,
              borderBottom: "1px solid #f3f3f3",
              fontWeight: 550,
              fontSize: 14,
              display: "flex",
              justifyContent: "space-between",
            }}>
            <div>{name}</div>
            {nodeData.visiable && (
              <Popover.Menu
                className="popovermenu"
                actions={actions}
                onAction={(node) => {
                  Toast.show(`选择了 ${node.text}`);
                  if (
                    defaultReportData &&
                    JSON.stringify(defaultReportData) !== "{}"
                  ) {
                    let arr = nodeData.data;
                    let flag = true;
                    for (let i = 0; i < arr.length; i++) {
                      if (arr[i].filterType === "date" && flag) {
                        arr[i].valueText = node.key;
                        flag = false;
                      }
                    }
                    fill(
                      defaultReportData,
                      undefined,
                      defaultReportData.preDefinedFiltersForAggregate,
                      defaultReportData.preDefinedFiltersForReport,
                      arr,
                      defaultReportData.reportFromRow
                    );

                    setNodeData((prevState: any) => ({
                      ...prevState,
                      text: node.text,
                    }));
                  }
                }}
                placement="bottom-start"
                trigger="click">
                <div style={{ fontWeight: 400, fontSize: 14 }}>
                  {nodeData.text}
                </div>
              </Popover.Menu>
            )}
          </div>
          <div style={{ padding: 8, paddingTop: 0 }}>
            <Chart
              dataSource={chartDataSource}
              chartType={chartType}
              description={dataSource}
              height={chartHeight}
              isApp={isApp}
            />
          </div>
        </>
      )}
    </>
  );
}
